import { I18n, localizeNumber } from "@devforce/trailhead-client-locale";

var data$9 = {
  minute: "~ %{m} Minute",
  minutes: "~ %{m} Minuten",
  hour: "~ %{h} Stunde",
  hours: "~ %{h} Stunden",
  hourMinute: "~ %{h} Stunde %{m} Minute",
  hourMinutes: "~ %{h} Stunde %{m} Minuten",
  hoursMinute: "~ %{h} Stunden %{m} Minute",
  hoursMinutes: "~ %{h} Stunden %{m} Minuten",
  minuteLeft: "~ noch %{m} Minute",
  minutesLeft: "~ noch %{m} Minuten",
  hourLeft: "~ noch %{h} Stunde",
  hoursLeft: "~ noch %{h} Stunden",
  hourMinuteLeft: "~ noch %{h} Stunde %{m} Minute",
  hourMinutesLeft: "~ noch %{h} Stunde %{m} Minuten",
  hoursMinuteLeft: "~ noch %{h} Stunden %{m} Minute",
  hoursMinutesLeft: "~ noch %{h} Stunden %{m} Minuten",
  zero: "0 Punkte",
  one: "+1 Punkt",
  many: "+%{p} Punkte",
  inProgressOne: "+1 Punkt gesammelt",
  inProgressMany: "+%{p} Punkte gesammelt",
  defaultPlaygroundName: "Mein Trailhead Playground",
};
data$9.minute;
data$9.minutes;
data$9.hour;
data$9.hours;
data$9.hourMinute;
data$9.hourMinutes;
data$9.hoursMinute;
data$9.hoursMinutes;
data$9.minuteLeft;
data$9.minutesLeft;
data$9.hourLeft;
data$9.hoursLeft;
data$9.hourMinuteLeft;
data$9.hourMinutesLeft;
data$9.hoursMinuteLeft;
data$9.hoursMinutesLeft;
data$9.zero;
data$9.one;
data$9.many;
data$9.inProgressOne;
data$9.inProgressMany;
data$9.defaultPlaygroundName;

var data$8 = {
  minute: "~%{m} min",
  minutes: "~%{m} mins",
  hour: "~%{h} hr",
  hours: "~%{h} hrs",
  hourMinute: "~%{h} hr %{m} min",
  hourMinutes: "~%{h} hr %{m} mins",
  hoursMinute: "~%{h} hrs %{m} min",
  hoursMinutes: "~%{h} hrs %{m} mins",
  minuteLeft: "~%{m} min left",
  minutesLeft: "~%{m} mins left",
  hourLeft: "~%{h} hr left",
  hoursLeft: "~%{h} hrs left",
  hourMinuteLeft: "~%{h} hr %{m} min left",
  hourMinutesLeft: "~%{h} hr %{m} mins left",
  hoursMinuteLeft: "~%{h} hrs %{m} min left",
  hoursMinutesLeft: "~%{h} hrs %{m} mins left",
  zero: "0 Points",
  one: "+1 Point",
  many: "+%{p} Points",
  inProgressOne: "+1 Point Earned",
  inProgressMany: "+%{p} Points Earned",
  defaultPlaygroundName: "My Trailhead Playground",
};
data$8.minute;
data$8.minutes;
data$8.hour;
data$8.hours;
data$8.hourMinute;
data$8.hourMinutes;
data$8.hoursMinute;
data$8.hoursMinutes;
data$8.minuteLeft;
data$8.minutesLeft;
data$8.hourLeft;
data$8.hoursLeft;
data$8.hourMinuteLeft;
data$8.hourMinutesLeft;
data$8.hoursMinuteLeft;
data$8.hoursMinutesLeft;
data$8.zero;
data$8.one;
data$8.many;
data$8.inProgressOne;
data$8.inProgressMany;
data$8.defaultPlaygroundName;

var data$7 = {
  minute: "~%{m} minuto",
  minutes: "~%{m} minutos",
  hour: "~%{h} hora",
  hours: "~%{h} horas",
  hourMinute: "~%{h} hora %{m} minuto",
  hourMinutes: "~%{h} hora %{m} minutos",
  hoursMinute: "~%{h} horas %{m} minuto",
  hoursMinutes: "~%{h} horas %{m} minutos",
  minuteLeft: "~%{m} minuto restante",
  minutesLeft: "~%{m} minutos restantes",
  hourLeft: "~%{h} hora restante",
  hoursLeft: "~%{h} horas restantes",
  hourMinuteLeft: "~%{h} hora y %{m} minuto restantes",
  hourMinutesLeft: "~%{h} hora y %{m} minutos restantes",
  hoursMinuteLeft: "~%{h} horas y %{m} minuto restantes",
  hoursMinutesLeft: "~%{h} horas %{m} minutos restantes",
  zero: "0 puntos",
  one: "+1 punto",
  many: "+%{p} puntos",
  inProgressOne: "+1 punto ganado",
  inProgressMany: "+%{p} puntos ganados",
  defaultPlaygroundName: "Mi Trailhead Playground",
};
data$7.minute;
data$7.minutes;
data$7.hour;
data$7.hours;
data$7.hourMinute;
data$7.hourMinutes;
data$7.hoursMinute;
data$7.hoursMinutes;
data$7.minuteLeft;
data$7.minutesLeft;
data$7.hourLeft;
data$7.hoursLeft;
data$7.hourMinuteLeft;
data$7.hourMinutesLeft;
data$7.hoursMinuteLeft;
data$7.hoursMinutesLeft;
data$7.zero;
data$7.one;
data$7.many;
data$7.inProgressOne;
data$7.inProgressMany;
data$7.defaultPlaygroundName;

var data$6 = {
  minute: "~%{m} minuto",
  minutes: "~%{m} minutos",
  hour: "~%{h} hora",
  hours: "~%{h} horas",
  hourMinute: "~%{h} hora %{m} minuto",
  hourMinutes: "~%{h} hora %{m} minutos",
  hoursMinute: "~%{h} horas %{m} minuto",
  hoursMinutes: "~%{h} horas %{m} minutos",
  minuteLeft: "~%{m} minuto restante",
  minutesLeft: "~%{m} minutos restantes",
  hourLeft: "~%{h} hora restante",
  hoursLeft: "~%{h} horas restantes",
  hourMinuteLeft: "~%{h} hora y %{m} minuto restantes",
  hourMinutesLeft: "~%{h} hora y %{m} minutos restantes",
  hoursMinuteLeft: "~%{h} horas y %{m} minuto restantes",
  hoursMinutesLeft: "~%{h} horas %{m} minutos restantes",
  zero: "0 puntos",
  one: "+1 punto",
  many: "+%{p} puntos",
  inProgressOne: "+1 punto ganado",
  inProgressMany: "+%{p} puntos ganados",
  defaultPlaygroundName: "Mi Trailhead Playground",
};
data$6.minute;
data$6.minutes;
data$6.hour;
data$6.hours;
data$6.hourMinute;
data$6.hourMinutes;
data$6.hoursMinute;
data$6.hoursMinutes;
data$6.minuteLeft;
data$6.minutesLeft;
data$6.hourLeft;
data$6.hoursLeft;
data$6.hourMinuteLeft;
data$6.hourMinutesLeft;
data$6.hoursMinuteLeft;
data$6.hoursMinutesLeft;
data$6.zero;
data$6.one;
data$6.many;
data$6.inProgressOne;
data$6.inProgressMany;
data$6.defaultPlaygroundName;

var data$5 = {
  minute: "Environ %{m} min",
  minutes: "Environ %{m} min",
  hour: "Environ %{h} h",
  hours: "Environ %{h} h",
  hourMinute: "Environ %{h} h %{m} min",
  hourMinutes: "Environ %{h} h %{m} min",
  hoursMinute: "Environ %{h} h %{m} min",
  hoursMinutes: "Environ %{h} h %{m} min",
  minuteLeft: "Il reste environ %{m} min",
  minutesLeft: "Il reste environ %{m} min",
  hourLeft: "Il reste environ %{h} h",
  hoursLeft: "Il reste environ %{h} h",
  hourMinuteLeft: "Il reste environ %{h} h %{m} min",
  hourMinutesLeft: "Il reste environ %{h} h %{m} min",
  hoursMinuteLeft: "Il reste environ %{h} h %{m} min",
  hoursMinutesLeft: "Il reste environ %{h} h %{m} min",
  zero: "0 point",
  one: "+ 1 point",
  many: "+ %{p} points",
  inProgressOne: "+1 point gagné",
  inProgressMany: "+%{p} points gagnés",
  defaultPlaygroundName: "Mon Trailhead Playground",
};
data$5.minute;
data$5.minutes;
data$5.hour;
data$5.hours;
data$5.hourMinute;
data$5.hourMinutes;
data$5.hoursMinute;
data$5.hoursMinutes;
data$5.minuteLeft;
data$5.minutesLeft;
data$5.hourLeft;
data$5.hoursLeft;
data$5.hourMinuteLeft;
data$5.hourMinutesLeft;
data$5.hoursMinuteLeft;
data$5.hoursMinutesLeft;
data$5.zero;
data$5.one;
data$5.many;
data$5.inProgressOne;
data$5.inProgressMany;
data$5.defaultPlaygroundName;

var data$4 = {
  minute: "~%{m} minuto",
  minutes: "~%{m} minuti",
  hour: "~%{h} ora",
  hours: "~%{h} ore",
  hourMinute: "~%{h} ora %{m} minuto",
  hourMinutes: "~%{h} ora %{m} minuti",
  hoursMinute: "~%{h} ore %{m} minuto",
  hoursMinutes: "~%{h} ore %{m} minuti",
  minuteLeft: "~%{m} minuto rimasto",
  minutesLeft: "~%{m} minuti rimasti",
  hourLeft: "~%{h} ora rimasta",
  hoursLeft: "~%{h} ore rimaste",
  hourMinuteLeft: "~%{h} ora %{m} minuto rimasto",
  hourMinutesLeft: "~%{h} ora %{m} minuti rimasti",
  hoursMinuteLeft: "~%{h} ore %{m} minuto rimasto",
  hoursMinutesLeft: "~%{h} ore %{m} minuti rimasti",
  zero: "0 punti",
  one: "+1 punto",
  many: "+%{p} punti",
  inProgressOne: "+1 punto guadagnato",
  inProgressMany: "+%{p} punti guadagnati",
  defaultPlaygroundName: "Il mio Trailhead Playground",
};
data$4.minute;
data$4.minutes;
data$4.hour;
data$4.hours;
data$4.hourMinute;
data$4.hourMinutes;
data$4.hoursMinute;
data$4.hoursMinutes;
data$4.minuteLeft;
data$4.minutesLeft;
data$4.hourLeft;
data$4.hoursLeft;
data$4.hourMinuteLeft;
data$4.hourMinutesLeft;
data$4.hoursMinuteLeft;
data$4.hoursMinutesLeft;
data$4.zero;
data$4.one;
data$4.many;
data$4.inProgressOne;
data$4.inProgressMany;
data$4.defaultPlaygroundName;

var data$3 = {
  minute: "~ %{m} 分",
  minutes: "~ %{m} 分",
  hour: "~ %{h} 時間",
  hours: "~ %{h} 時間",
  hourMinute: "~ %{h} 時間 %{m} 分",
  hourMinutes: "~ %{h} 時間 %{m} 分",
  hoursMinute: "~ %{h} 時間 %{m} 分",
  hoursMinutes: "~ %{h} 時間 %{m} 分",
  minuteLeft: "~ 残り %{m} 分",
  minutesLeft: "~ 残り %{m} 分",
  hourLeft: "~ 残り %{h} 時間",
  hoursLeft: "~ 残り %{h} 時間",
  hourMinuteLeft: "~ 残り %{h} 時間 %{m} 分",
  hourMinutesLeft: "~ 残り %{h} 時間 %{m} 分",
  hoursMinuteLeft: "~ 残り %{h} 時間 %{m} 分",
  hoursMinutesLeft: "~ 残り %{h} 時間 %{m} 分",
  zero: "0 ポイント",
  one: "+1 ポイント",
  many: "+%{p} ポイント",
  inProgressOne: "+1 ポイント獲得",
  inProgressMany: "+%{p} ポイント獲得",
  defaultPlaygroundName: "私の Trailhead Playground",
};
data$3.minute;
data$3.minutes;
data$3.hour;
data$3.hours;
data$3.hourMinute;
data$3.hourMinutes;
data$3.hoursMinute;
data$3.hoursMinutes;
data$3.minuteLeft;
data$3.minutesLeft;
data$3.hourLeft;
data$3.hoursLeft;
data$3.hourMinuteLeft;
data$3.hourMinutesLeft;
data$3.hoursMinuteLeft;
data$3.hoursMinutesLeft;
data$3.zero;
data$3.one;
data$3.many;
data$3.inProgressOne;
data$3.inProgressMany;
data$3.defaultPlaygroundName;

var data$2 = {
  minute: "~%{m}분",
  minutes: "~%{m}분",
  hour: "~%{h}시간",
  hours: "~%{h}시간",
  hourMinute: "~%{h}시간 %{m}분",
  hourMinutes: "~%{h}시간 %{m}분",
  hoursMinute: "~%{h}시간 %{m}분",
  hoursMinutes: "~%{h}시간 %{m}분",
  minuteLeft: "~%{m}분 남음",
  minutesLeft: "~%{m}분 남음",
  hourLeft: "~%{h}시간 남음",
  hoursLeft: "~%{h}시간 남음",
  hourMinuteLeft: "~%{h}시간 %{m}분 남음",
  hourMinutesLeft: "~%{h}시간 %{m}분 남음",
  hoursMinuteLeft: "~%{h}시간 %{m}분 남음",
  hoursMinutesLeft: "~%{h}시간 %{m}분 남음",
  zero: "0포인트",
  one: "+1포인트",
  many: "+%{p} 포인트",
  inProgressOne: "+1포인트 획득",
  inProgressMany: "+%{p}포인트 획득",
  defaultPlaygroundName: "내 Trailhead Playground",
};
data$2.minute;
data$2.minutes;
data$2.hour;
data$2.hours;
data$2.hourMinute;
data$2.hourMinutes;
data$2.hoursMinute;
data$2.hoursMinutes;
data$2.minuteLeft;
data$2.minutesLeft;
data$2.hourLeft;
data$2.hoursLeft;
data$2.hourMinuteLeft;
data$2.hourMinutesLeft;
data$2.hoursMinuteLeft;
data$2.hoursMinutesLeft;
data$2.zero;
data$2.one;
data$2.many;
data$2.inProgressOne;
data$2.inProgressMany;
data$2.defaultPlaygroundName;

var data$1 = {
  minute: "~%{m} min",
  minutes: "~%{m} min",
  hour: "~%{h} h",
  hours: "~%{h} h",
  hourMinute: "~%{h} h %{m} min",
  hourMinutes: "~%{h} h %{m} min",
  hoursMinute: "~%{h} h %{m} min",
  hoursMinutes: "~%{h} h %{m} min",
  minuteLeft: "~%{m} min restante",
  minutesLeft: "~%{m} min restantes",
  hourLeft: "~%{h} h restante",
  hoursLeft: "~%{h} h restantes",
  hourMinuteLeft: "~%{h} h %{m} min restante(s)",
  hourMinutesLeft: "~%{h} h %{m} min restante(s)",
  hoursMinuteLeft: "~%{h} h %{m} min restantes",
  hoursMinutesLeft: "~%{h} h %{m} min restantes",
  zero: "0 pontos",
  one: "+1 ponto",
  many: "+%{p} pontos",
  inProgressOne: "+1 ponto ganho",
  inProgressMany: "+%{p} pontos ganhos",
  defaultPlaygroundName: "Meu Trailhead Playground",
};
data$1.minute;
data$1.minutes;
data$1.hour;
data$1.hours;
data$1.hourMinute;
data$1.hourMinutes;
data$1.hoursMinute;
data$1.hoursMinutes;
data$1.minuteLeft;
data$1.minutesLeft;
data$1.hourLeft;
data$1.hoursLeft;
data$1.hourMinuteLeft;
data$1.hourMinutesLeft;
data$1.hoursMinuteLeft;
data$1.hoursMinutesLeft;
data$1.zero;
data$1.one;
data$1.many;
data$1.inProgressOne;
data$1.inProgressMany;
data$1.defaultPlaygroundName;

var data = {
  minute: "~%{m} 分钟",
  minutes: "~%{m} 分钟",
  hour: "~%{h} 小时",
  hours: "~%{h} 小时",
  hourMinute: "~%{h} 小时 %{m} 分钟",
  hourMinutes: "~%{h} 小时 %{m} 分钟",
  hoursMinute: "~%{h} 小时 %{m} 分钟",
  hoursMinutes: "~%{h} 小时 %{m} 分钟",
  minuteLeft: "剩余 ~%{m} 分钟",
  minutesLeft: "剩余 ~%{m} 分钟",
  hourLeft: "剩余 ~%{h} 小时",
  hoursLeft: "剩余 ~%{h} 小时",
  hourMinuteLeft: "剩余 ~%{h} 小时 %{m} 分钟",
  hourMinutesLeft: "剩余 ~%{h} 小时 %{m} 分钟",
  hoursMinuteLeft: "剩余 ~%{h} 小时 %{m} 分钟",
  hoursMinutesLeft: "剩余 ~%{h} 小时 %{m} 分钟",
  zero: "0 分",
  one: "+1 分",
  many: "+%{p} 分",
  inProgressOne: "获得 1 分",
  inProgressMany: "获得 %{p} 分",
  defaultPlaygroundName: "我的 Trailhead Playground",
};
data.minute;
data.minutes;
data.hour;
data.hours;
data.hourMinute;
data.hourMinutes;
data.hoursMinute;
data.hoursMinutes;
data.minuteLeft;
data.minutesLeft;
data.hourLeft;
data.hoursLeft;
data.hourMinuteLeft;
data.hourMinutesLeft;
data.hoursMinuteLeft;
data.hoursMinutesLeft;
data.zero;
data.one;
data.many;
data.inProgressOne;
data.inProgressMany;
data.defaultPlaygroundName;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const i18n = new I18n({
  helpers: locales,
});
function label(labelKey, values = []) {
  if (values.length) {
    return i18n.t("helpers", labelKey, {
      h: values[0].toString(),
      m: (values.length === 2 && values[1].toString()) || values[0].toString(),
      p: values[0].toString(),
    });
  } else return i18n.t("helpers", labelKey);
}

function hoursMinutesLabelArgs(timeInMinutes) {
  const hrs = Math.floor(timeInMinutes / 60);
  const mins = timeInMinutes % 60;
  let key = "";
  let values = [];
  if (hrs > 0) {
    values.push(hrs);
  }
  values.push(mins);
  if (hrs === 0 && mins === 0) {
    key = "minutes";
  }
  if (hrs === 0 && mins === 1) {
    key = "minute";
  }
  if (hrs === 0 && mins > 1) {
    key = "minutes";
  }
  if (hrs === 1 && mins === 0) {
    key = "hour";
  }
  if (hrs === 1 && mins === 1) {
    key = "hourMinute";
  }
  if (hrs === 1 && mins > 1) {
    key = "hourMinutes";
  }
  if (hrs > 1 && mins === 0) {
    key = "hours";
  }
  if (hrs > 1 && mins === 1) {
    key = "hoursMinute";
  }
  if (hrs > 1 && mins > 1) {
    key = "hoursMinutes";
  }
  return {
    key,
    values,
  };
}
function hoursMinutesLabel(timeInMinutes) {
  let labelInfo = hoursMinutesLabelArgs(timeInMinutes);
  return timeInMinutes ? label(`${labelInfo.key}`, labelInfo.values) : "";
}
function hoursMinutesLeftLabel(timeInMinutes) {
  let labelInfo = hoursMinutesLabelArgs(timeInMinutes);
  return timeInMinutes ? label(`${labelInfo.key}Left`, labelInfo.values) : "";
}

function pointLabel(points) {
  if (points !== undefined) {
    if (points === 0) {
      return label("zero", [points]);
    } else if (points === 1) {
      return label("one", [points]);
    } else {
      return label("many", [localizeNumber(points)]);
    }
  }
}
function inProgressPointLabel(points) {
  if (points !== undefined) {
    if (points === 1) {
      return label("inProgressOne", [points]);
    } else {
      return label("inProgressMany", [localizeNumber(points)]);
    }
  }
}

export {
  hoursMinutesLabel,
  hoursMinutesLeftLabel,
  inProgressPointLabel,
  label,
  pointLabel,
};
